module.exports = __webpack_public_path__ + "img/logo-100x100.3360574f.png";